module.exports = __webpack_public_path__ + "static/img/73c08ed77f371847f791ff15a86a76c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品与服务-改(1)_47.jpg
// module id = 6Czd
// module chunks = 1